import {UPDATE_WINDOW} from "../Actions/window";

const initialState = {
    width: null,
    height: null
};

const reducer = (state = initialState, action) => {
    let newState = {...state};

    switch (action.type) {
        case UPDATE_WINDOW:
            delete action.type;
            newState = {
                ...state,
                ...action
            };
            break;

        default:
            return newState;
    }

    return newState;
};

export default reducer